export default "__VITE_ASSET__2318d814__"